import { render } from "./Erazer.vue?vue&type=template&id=19e43214"
import script from "./Erazer.vue?vue&type=script&lang=js"
export * from "./Erazer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__